export default __webpack_public_path__ + "static/media/importexport3.9039f51d.png";